var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"simple-page"},[_c('Container',{attrs:{"lock-axis":"y"},on:{"drop":_vm.onDrop}},_vm._l((_vm.items),function(item){return _c('Draggable',{key:item.id},[_c('div',{staticClass:"draggable-item"},[_vm._v("\n        "+_vm._s(item.data)+"\n      ")])])}),1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53fbe1a9","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/lock-axis.vue
// module id = 69
// module chunks = 0